import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  stepNo: 0,
  goalNumber: 0,
  markAsDoneGoal: 0,
};

const setGoalsSlice = createSlice({
  name: 'setGoals',
  initialState,
  reducers: {
    saveStepNo(state, action) {
      state.stepNo = action.payload;
    },
    saveCompleteGoalNumber(state, action) {
      state.goalNumber = action.payload;
    },
    saveMarkAsDoneGoal(state, action) {
      state.markAsDoneGoal = action.payload;
    },
  },
});

export const { saveStepNo, saveCompleteGoalNumber, saveMarkAsDoneGoal } =
  setGoalsSlice.actions;

export default setGoalsSlice.reducer;
